export function normalizeUrl(url: string): string {
  return (url.lastIndexOf('/', url.length - 1) === url.length - 1
    ? url
    : `${url}/`
  )
    .trim()
    .toLowerCase();
}
